import React, { useEffect, useState } from 'react'
import { Button, Container, Dropdown, Nav, Table } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import { TableSkeleton } from '../../Utils/skeletonLoader/TableSkeleton'
import { DescriptionTooltip } from '../../Utils/helpers/descriptionTooltip/DescriptionTooltip'
import { formatDate } from '../../Utils/helpers/commonhelper'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faEllipsisVertical, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons'
import CreateRoundRobinOffcanvas from './CreateRoundRobinOffcanvas'
import { DeleteRequest, GetRequest, PutRequest } from '../../Utils/hooks/ApiHandler'
import { baseURL } from '../../Utils/constants/constant'
import useLocalStorageState from 'use-local-storage-state'
import { toast } from 'sonner'
import DeleteModal from '../DeleteModal'
import nodata from "../../Utils/assets/img/leads_no_data_found.png";
const RoundRobin = () => {

  const navigate = useNavigate();
  const [customer, setCustomer] = useLocalStorageState("customer", {
    token: {},
  });
  // rbac permission object
  const [PERMISSION] = useLocalStorageState('permission');

  const customerId = customer?.customer_details?.customer_id;
  const token = customer?.token?.authorization;
  const rf = customer?.token?.authentication;
  const headers = { authentication: rf, Authorization: token };
  const extras = { customer, setCustomer, rf, navigate };

  // permissions to handle
  const workflowGrants = PERMISSION?.workflow;
  const isWorkFlow = workflowGrants?.isAuthorized;

  const [isLoading, setIsLoading] = useState(false)
  const [editedId, setEditedId] = useState(null)
  const [openRow, setOpenRow] = useState(null)
  const [searchTerm, setSearchTerm] = useState('')
  const [showcanvas, setShowCanvas] = useState(false)
  const [roundRobinData, setRoundRobinData] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [workflowToDelete, setWorkFlowToDelete] = useState();
  const handleAddClick = () => {
    if (workflowGrants.isCreate) {
      setShowCanvas(true)
    }
    else {
      return toast.warning("your are not authorised to create workflow")
    }
  }
  const location = useLocation();
  const currentPath = location.pathname;

  const fetchRoundRobin = async () => {
    try {
      setIsLoading(true)
      const res = await GetRequest(`${baseURL}workflow/fetchDistributionWorkflow/${customerId}/${customer?.customer_details?.id}`, { headers }, extras)
      if (res?.status === "fail" || res?.status !== "success") {
        return toast.error(res?.message || "something went wrong!!")
      }
      if (res?.status === "success") {
        // toast.success(res?.message||"something went wrong!!")
        setRoundRobinData(res?.data)
      }
    } catch (error) {
      console.error("error in fetching data : ", error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchRoundRobin()
  }, [])

  const onDelete = (workflow_id) => {
    if (workflowGrants?.isDelete) {
      setWorkFlowToDelete(workflow_id);
      setShowDeleteModal(true);
    } else {
      return toast.warning("you are not authorised to delete workflow");
    }
  };

  const handleConfirmedDelete = async () => {
    setIsLoading(true)
    try {
      const res = await DeleteRequest(
        `workflow/deleteWorkflow/${customerId}/${workflowToDelete}`,
        { headers },
        extras
      );
      if (res?.status === "success") {
        fetchRoundRobin()
        toast.success(res.message);
        setRoundRobinData((prev) =>
          prev.filter((item) => item.id !== workflowToDelete)
        );
      } else {
        toast.error(res.message || "Delete failed");
      }
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false)
      setShowDeleteModal(false);
      setWorkFlowToDelete(null);
    }
  };


  // Toggle Switch Component
  // const ToggleSwitch = ({ active, onClick }) => {
  //   return (
  //     <div
  //       className={`toggle-switch ${active ? "active" : ""}`}
  //       onClick={onClick}
  //       style={{
  //         width: "30px",
  //         height: "14px",
  //         backgroundColor: active ? "#4CAF50" : "#ccc",
  //         borderRadius: "12px",
  //         position: "relative",
  //         cursor: "pointer",
  //         transition: "background-color 0.3s",
  //       }}
  //     >
  //       <div
  //         className="toggle-switch-handle"
  //         style={{
  //           width: "10px",
  //           height: "10px",
  //           backgroundColor: "white",
  //           borderRadius: "50%",
  //           position: "absolute",
  //           top: "2px",
  //           left: active ? "19px" : "2px",
  //           transition: "left 0.3s",
  //         }}
  //       />
  //     </div>
  //   );
  // };

  // Handle status toggle
  // const handleStatusToggle = async (templateId) => {
  //   try {
  //     setIsLoading(true);

  //     const payload = {
  //       customer_id: customerId,
  //       workflow_id: templateId?.workflow_id,
  //     };
  //     const res = await PutRequest(
  //       `${baseURL}workflow/changeStatusOfWorkflow/`,
  //       payload,
  //       { headers },
  //       extras
  //     );
  //     if (res.status === "success") {
  //       toast.success(res.message);
  //       fetchRoundRobin();
  //     } else {
  //       toast.error(res.message || "Failed to update status");
  //     }
  //   } catch (error) {
  //     console.error("Error updating template status:", error);
  //     toast.error("Failed to update template status");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const filteredWorkflows = roundRobinData.filter(
    (w) =>
      w.workflow_name
        ?.toLowerCase()
        .includes(searchTerm.trim().toLowerCase()) ||
      w.module_name?.toLowerCase().includes(searchTerm.trim().toLowerCase()) ||
      w.trigger?.toLowerCase().includes(searchTerm.trim().toLowerCase())
  );


  const handleEditClick = (id) => {
    if (workflowGrants.isEdit) {
      setShowCanvas(true)
      setEditedId(id)
    } else {
      return toast.warning("your are not authorised to edit workflow");
    }

  }
  return (<>


    <DeleteModal
      show={showDeleteModal}
      onClose={() => setShowDeleteModal(false)}
      onConfirm={handleConfirmedDelete}
      isLoading={isLoading}
      message="Are you sure you want to delete this item?"
    />
    {showcanvas &&
      <CreateRoundRobinOffcanvas
        show={showcanvas}
        setShowCanvas={setShowCanvas}
        setEditedId={setEditedId}
        editedId={editedId}
        fetchRoundRobin={fetchRoundRobin}
      />
    }
    <div className=" pb-1 d-flex justify-content-between align-items-center">

      <div className="d-flex align-items-center">
        <span
          onClick={() => navigate("/workflow")}
          className={`tab-button ${currentPath === "/workflow" ? "active-tab" : "inactive-tab"}`}
        >
          Workflow
        </span>

        <span
          onClick={() => navigate("/roundrobin")}
          className={`tab-button ${currentPath === "/roundrobin" ? "active-tab" : "inactive-tab"}`}
        >
          Round Robin
        </span>
      </div>
      <div
        className="d-flex align-items-center gap-1"
        style={{ height: "39px" }}
      >
        <div
          className=" position-relative  mb-2 md-0"
          style={{ marginTop: "7px" }}
        >
          <input
            type="search"
            className="form-control "
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              fontSize: "12px",
              paddingLeft: "36px",
              height: "35px",
            }}
          />
          <i
            className="fa-solid fa-magnifying-glass"
            style={{
              position: "absolute",
              marginTop: "-26px",
              zIndex: 1,
              marginLeft: "13px",
            }}
          ></i>
        </div>

        <Button
          type="button"
          className="btn btn-default"
          style={{
            height: "33px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={handleAddClick}
        >
          <FontAwesomeIcon icon={faPlus} className="pe-1" /> Add
        </Button>
      </div>
    </div>

    <Container
      fluid
      style={{
        fontFamily: "'Poppins', sans-serif",
        height: "calc(100vh - 11rem)",
        backgroundColor: "white",
        padding: 0,
        animation: "cardEntry 1s ease-out forwards",
      }}
      className="mt-3 p-0"
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          width: "100%",
        }}
      >
        <div
          className="listStyleForContact container-table"
          style={{
            flex: 10 > 10 ? 1 : "auto",
            overflow: "auto",
            width: "100%",
            maxHeight: 10 > 10 ? "100%" : "auto",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.scrollbarColor = "#e0e0e0 white";
          }}
        >
          {workflowGrants.isView ? (
            <>
              <Table
                style={{
                  width: "100%",
                  tableLayout: "auto",
                  backgroundColor: "white",
                  marginBottom: "0px",
                }}
              >
                <thead style={{ backgroundColor: "#f3effe", zIndex: "10" }}>
                  <tr>
                    <th>S.No</th>
                    {/* <th>Module Name</th>
                        <th>Trigger</th> */}
                    <th>WorkFlow Name</th>
                    <th>Description</th>
                    {/* <th>STATUS</th> */}
                    <th>Created At</th>
                    <th>Created By</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <TableSkeleton columnCount={7} rowCount={7} />
                  ) : filteredWorkflows.length === 0 ? (
                    <tr>
                      <td
                        colSpan="14"
                        style={{ textAlign: "center", color: "gray" }}
                      >
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{ position: "absolute", left: "42%" }}
                        >
                          <img
                            src={nodata}
                            alt="No data"
                            style={{ width: "17rem" }}
                          />
                        </div>
                      </td>
                    </tr>
                  ) : (
                    filteredWorkflows.map((workflow, index) => (
                      <tr key={workflow.id} style={{ zIndex: openRow === workflow.id ? 11 : "auto", }}>
                        <td>{index + 1}</td>
                        {/* <td>{workflow.module_name}</td>
                            <td>{workflow.trigger}</td> */}
                        <td>{workflow.workflow_name}</td>
                        <td>
                          <DescriptionTooltip
                            text={workflow.description || "-"}
                            maxLength={20}
                          />
                        </td>
                        {/* <td>
                          <ToggleSwitch
                            active={workflow.status === "active"}
                            onClick={() => handleStatusToggle(workflow)}
                          />
                        </td> */}
                        <td>{formatDate(workflow.created_at)}</td>
                        <td>{workflow.owner_full_name || "-"}</td>

                        <td
                          className="lastactionTd"
                          style={{
                            paddingRight: "14px",
                            paddingLeft: "14px",

                          }}
                        >
                          {" "}
                          <div>
                            {" "}
                            <Dropdown
                              as="div"
                              className="dropdownsWithoutToggle"
                              onToggle={(isOpen) =>
                                setOpenRow(isOpen ? workflow.id : null)
                              }
                            >
                              {" "}
                              <Dropdown.Toggle
                                as={Nav.Link}
                                className="header-link"
                              >
                                {" "}
                                <FontAwesomeIcon
                                  style={{
                                    width: "15px",
                                    height: "15px",
                                    color: "#536485",
                                  }}
                                  icon={faEllipsisVertical}
                                />{" "}
                              </Dropdown.Toggle>{" "}
                              <Dropdown.Menu
                                align={"end"}
                                style={{
                                  width: "7rem",
                                  inset: "0px auto auto 0px",
                                  boxShadow:
                                    "rgb(215, 215, 215) 0px 0px 15px",
                                  position: "absolute",
                                  marginTop: "-22px",
                                  marginRight: "47px",
                                  minWidth: "3rem",
                                  zIndex: 1000,
                                }}
                              >
                                {" "}
                                <>
                                  {" "}
                                  <Dropdown.Item
                                    href="#"
                                    className="d-flex align-items-center"
                                    onClick={() => {
                                      handleEditClick(workflow?.workflow_id);
                                    }}
                                  >
                                    {" "}
                                    <FontAwesomeIcon
                                      icon={faEdit}
                                      style={{
                                        width: "16px",
                                        height: "16px",
                                        marginRight: "9px",
                                        color: "#5e5f60",
                                      }}
                                    />{" "}
                                    Edit{" "}
                                  </Dropdown.Item>{" "}
                                </>{" "}
                                <Dropdown.Item
                                  href="#"
                                  className="d-flex align-items-center"
                                  onClick={() => onDelete(workflow?.workflow_id)}
                                >
                                  {" "}
                                  <FontAwesomeIcon
                                    icon={faTrash}
                                    style={{
                                      width: "16px",
                                      height: "16px",
                                      marginRight: "9px",
                                      color: "#5e5f60",
                                    }}
                                  />{" "}
                                  Delete{" "}
                                </Dropdown.Item>{" "}
                              </Dropdown.Menu>{" "}
                            </Dropdown>{" "}
                          </div>{" "}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </>
          ) : (
            <>
              <tr>
                <td
                  colSpan="14"
                  style={{ textAlign: "center", color: "gray" }}
                >
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ position: "absolute", left: " 42%" }}
                  >
                    <img
                      src={nodata}
                      alt=""
                      style={{ width: "17rem", marginTop: "0" }}
                    />
                  </div>
                </td>
              </tr>
            </>
          )}
        </div>
      </div>
    </Container>
  </>
  )
}

export default RoundRobin
